import React, { useState, useEffect } from "react";
import sanityClient from "../client";
import "./styles/Media.scss";

const Media = () => {
  const [photos, setPhotos] = useState([]);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    sanityClient
      .fetch(
        `*[_type == "photoGallery"]{
          _id,
          description,
          "imageUrl": image.asset->url
        }`
      )
      .then((data) => setPhotos(data))
      .catch(console.error);
  }, []);

  const openLightbox = (index) => {
    setCurrentIndex(index);
    setLightboxOpen(true);
  };

  const closeLightbox = () => {
    setLightboxOpen(false);
  };

  const goToPrevious = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? photos.length - 1 : prevIndex - 1
    );
  };

  const goToNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === photos.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div className="media-container">
      <div className="photo-gallery">
        {photos.length > 0 ? (
          photos.map((photo, index) => (
            <div key={photo._id} className="photo-item">
              <img
                src={photo.imageUrl}
                alt={photo.description || "Gallery Image"}
                onClick={() => openLightbox(index)}
              />
              <p>{photo.description}</p>
            </div>
          ))
        ) : (
          <p>Loading photos...</p>
        )}
      </div>

      {lightboxOpen && (
        <div className="lightbox">
          <button onClick={goToPrevious} className="prev-button">
            &#9664;
          </button>
          <div className="lightbox-content">
            <img
              src={photos[currentIndex].imageUrl}
              alt={photos[currentIndex].description || "Gallery Image"}
              className="lightbox-image"
            />
            <div
              className={`lightbox-description fade-in`}
              key={photos[currentIndex]._id} // Unique key to reset animation
            >
              <p>{photos[currentIndex].description}</p>
            </div>
          </div>
          <button onClick={goToNext} className="next-button">
            &#9654;
          </button>
          <button onClick={closeLightbox} className="close-button">
            ✕
          </button>
        </div>
      )}
    </div>
  );
};

export default Media;
